export const PRODUCT_NOT_FOUND_ERROR = 'Product not found';
